const Const = {

    REQUEST_STATUSES: {
        pending: {
            name: 'pending',
            color: '#17a2b8',
            variant: 'info',
            label: 'in attesa di pagamento',
            icon: 'flaticon-hourglass',
            step: 1
        },
        paid: {
            name: 'paid',
            color: '#8D835C',
            variant: 'secondary',
            label: 'pagata',
            icon: 'flaticon-euro',
            step: 3
        },
        completed: {
            name: 'completed',
            color: '#28a745',
            variant: 'success',
            label: 'completata',
            icon: 'flaticon-racing-flag',
            step: 4
        },
        warning: {
            name: 'warning',
            color: '#ffc107',
            variant: 'warning',
            label: 'warning',
            icon: 'flaticon-danger',
            step: 5
        },
        rejected: {
            name: 'rejected',
            color: '#dc3545',
            variant: 'danger',
            label: 'respinta',
            icon: 'flaticon-delete-button',
            step: 5
        },
    },

    PAYMENT_STATUSES: {
        pending: {
            name: 'pending',
            variant: 'warning',
            label: 'in attesa',

        },
        completed: {
            name: 'completed',
            variant: 'success',
            label: 'completata',
        },
    },

    NOTICE_LEVELS: {
        info: {name: 'info', variant: 'info'},
        warning: {name: 'warning', variant: 'warning'},
        danger: {name: 'danger', variant: 'danger'},
    },

    CONTACT_SENIOR: 'senior',
    CONTACT_JUNIOR: 'junior',

    PAYMENT_BONIFICO: 'bonifico',
    PAYMENT_CC: 'cc'

};

export default Const;
